module.exports = "<top-bar></top-bar>\n<div class=\"thanks\">\n  <div class=\"div-block-17\">\n    <div class=\"header\">\n      <span>תודה רבה!</span>\n    </div>\n    <div class=\"content\">\n      <div class=\"thanks-title\">אנו מודים לך על תרומתך.<br></div>\n      <p class=\"paragraph-3\"><strong class=\"bold-text-5\">בתרומתך זו, זכית לקחת חלק בעתידם הטהור של כלל ישראל, ובהצלת נפשות ברשת האינטרנט.</strong><br></p>\n      <div class=\"line\">\n        <i class=\"fa fa-heart\"></i>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/thanks/thanks.html
// module id = 528
// module chunks = 0